import { forwardRef } from 'react';

import { ClubCurrencyIconV2 } from '@wwe-portal/ui/components/icons';
import { AddClubCurrencyIcon } from '@wwe-portal/ui/components/icons/add-club-coin-icon';

export interface ClubCoinAmountProps {
  clubCoin: number;
  onClickAdd: () => void;
}

export const ClubCoinAmount = forwardRef<HTMLDivElement, ClubCoinAmountProps>(
  ({ clubCoin, onClickAdd }: ClubCoinAmountProps, ref) => {
    return (
      <div
        className="relative h-[22px] w-[106px] pl-[13px] pr-[11px]"
        data-theme="dark"
        ref={ref}
      >
        <div className="inset-l-[14px] inset-r-[11px] bg-back200 text-text300 absolute inset-y-0 w-[82px] text-center font-bold">
          {clubCoin}
        </div>
        <div className="absolute inset-y-0 left-0 h-[22px] w-[26px]">
          <ClubCurrencyIconV2 className="text-goldtier absolute inset-x-0 bottom-0 top-[-1.5px] ml-[3px] size-full h-6 w-[23px]" />
        </div>
        <AddClubCurrencyIcon
          className="absolute inset-y-0 right-0 size-[22px] h-[22px] w-[21px] cursor-pointer rounded-full"
          onClick={onClickAdd}
        />
      </div>
    );
  }
);

ClubCoinAmount.displayName = 'ClubCoinAmount';
